import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import Banner from "../Banner"
import SlickCarouselArrow from "../SlickCarouselArrow/index"
import "./styles.css"
import { useEffect, useRef } from "react"

const SlickCarousel = ({ data, itemsPerPage }) => {
  const { banner } = data
  const sliderRef = useRef(null)

  useEffect(() => {
    return () => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(0)
      }
    }
  }, [])

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: itemsPerPage,
    slidesToScroll: 1,
    touchThreshold: 100,
    prevArrow: <SlickCarouselArrow side="left" />,
    nextArrow: <SlickCarouselArrow side="right" />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          touchThreshold: 100,
        },
      },
    ],
  }

  return (
    <div className="slider-container banners-slider">
      <Slider ref={sliderRef} {...settings}>
        {banner
          .sort((a, b) =>
            a.orden === b.orden ? 0 : a.orden > b.orden ? 1 : -1
          )
          .map((bannerData) => (
            <Banner key={bannerData.id} data={bannerData} />
          ))}
      </Slider>
    </div>
  )
}

export default SlickCarousel
